import React, {
    useState,
    useEffect,
    useContext
}
from "react";

import {
    useParams
}
from "react-router-dom";

import {
    store
}
from "../context/store";

import {
    functions
}
from "../constants/common-functions";

import Header
from "../components/Header";

import LeftMenu
from "../components/LeftMenu";

import GoogleMap
from "../components/GoogleMap";

import MobileHeader
from "./home/mobile/components/MobileHeader";

import MobileMenu
from "./home/mobile/components/MobileMenu";


export default function Map()
{

    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const siteId =
        useParams()["siteId"];


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [loaded, setLoaded] =
        useState(false);

    const [locations, setLocations] =
        useState([]);

    const [facilityTypeMaps, setFacilityTypeMaps] =
        useState([]);

    const [mobileMenuOpen, setMobileMenuOpen] =
        useState(false);


    //--------------------------------------------------------
    // Mobile
    //--------------------------------------------------------

    const isMobile =
        window.innerWidth <= 768;


    //========================================================
    // Data load
    //========================================================

    useEffect(
        function()
        {

            if(!loaded)
            {

                functions.getArrayFromAjax(
                    "/resolutionsoftwareplatform/facilitytypemaps?siteId=-100",
                    setFacilityTypeMaps,
                    populateLocations
                );

                setLoaded(
                    true
                );

            }

        },
        [loaded]
    );


    const populateLocations =
        function()
        {

            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/facilitiesformap?siteId=-100",
                setLocations,
                null
            );

        };


    //========================================================
    // Styles
    //========================================================

    const thisContainer =
    {
        display:
            "flex",

        flexDirection:
            "column",

        height:
            "100vh",

        width:
            "100%",

        overflow:
            "hidden"
    };


    //--------------------------------------------------------
    // Main content
    //--------------------------------------------------------

    const mainContainer =
    {
        display:
            "flex",

        flexDirection:
            "column",

        marginLeft:
            isMobile
                ?
                "0px"
                :
                "60px",

        marginTop:
            "0px",

        width:
            isMobile
                ?
                "100%"
                :
                "calc(100% - 60px)",

        flexGrow:
            1,

        minHeight:
            0,

        overflow:
            "hidden"
    };


    //--------------------------------------------------------
    // Map
    //--------------------------------------------------------

    const mapInner =
    {
        width:
            "100%",

        height:
            "100%",

        minHeight:
            0
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div style={thisContainer}>


            {/* ==============================================
                DESKTOP HEADER / MENU
            ============================================== */}

            {
                !isMobile
                &&
                <>

                    <Header
                        transitionHide={true}
                    />

                    <LeftMenu />

                </>
            }


            {/* ==============================================
                MOBILE HEADER
            ============================================== */}

            {
                isMobile
                &&
                <MobileHeader
                    openMenu={
                        function()
                        {

                            setMobileMenuOpen(
                                true
                            );

                        }
                    }
                />
            }


            {/* ==============================================
                MAP
            ============================================== */}

            <div style={mainContainer}>

                <div style={mapInner}>

                    <GoogleMap
                        facilityTypeMaps={facilityTypeMaps}
                        locations={locations}
                        parentId="-100"
                        isMobile={isMobile}
                    />

                </div>

            </div>


            {/* ==============================================
                MOBILE MENU
            ============================================== */}

            {
                isMobile
                &&
                <MobileMenu
                    display={mobileMenuOpen}
                    closeFunction={
                        function()
                        {

                            setMobileMenuOpen(
                                false
                            );

                        }
                    }
                />
            }


        </div>

    );

}